<template>
  <div class="mb-3">
    <slot />
  </div>
</template>
